import * as React from "react";
import { QrcodeCanvas, useQrcodeDownload } from "react-qrcode-pretty";

interface UserQRCodeProps {
    userId: string;
    userName?: string;
    onClose?: () => void;
}

const UserQRCode: React.FC<UserQRCodeProps> = ({ userId, userName, onClose }) => {
    const [qrSize, setQrSize] = React.useState(200);

    React.useEffect(() => {
        const updateSize = () => {
            setQrSize(window.innerWidth < 640 ? 160 : 200);
        };
        
        updateSize();
        window.addEventListener('resize', updateSize);
        
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    return (
        <div className="bg-white bg-opacity-95 backdrop-blur-sm rounded-2xl p-4 sm:p-6 shadow-lg text-center" style={{ borderLeft: `4px solid #DB1C7D` }}>
            <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg sm:text-xl font-bold" style={{ color: "#013A51" }}>
                    Your QR Code
                </h3>
                {onClose && (
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors duration-200 p-1" aria-label="Close QR Code">
                        <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                )}
            </div>

            <div className="mb-4">
                <div className="inline-block p-3 sm:p-4 rounded-xl shadow-md" style={{ backgroundColor: "rgba(241, 245, 248, 0.8)" }}>
                    <QrcodeCanvas
                        value={userId}
                        size={qrSize}
                        variant={{
                            eyes: "gravity",
                            body: "fluid",
                        }}
                        color={{
                            eyes: "#013A51",
                            body: "#013A51",
                        }}
                        padding={20}
                        margin={20}
                        bgColor="#ffffff"
                        bgRounded
                        divider
                    />
                </div>
            </div>

            {userName && (
                <p className="text-base sm:text-lg font-semibold mb-2" style={{ color: "#013A51" }}>
                    {userName}
                </p>
            )}

            <p className="text-xs sm:text-sm mb-4" style={{ color: "#708372" }}>
                Show this QR code for ticket assignment or verification
            </p>

            <div className="bg-gray-50 rounded-lg p-3">
                <p className="text-xs font-mono text-gray-600 break-all">
                    User ID: {userId}
                </p>
            </div>
        </div>
    );
};

export default UserQRCode;
